import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQrCodeModal } from "../feature-module/userDashboard/myBooking/QrCodeModalContext";
import QrCodeModal from "../feature-module/userDashboard/myBooking/QrCodeModal";

const AppInitializer = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { openModal, isOpen, qrCodeData } = useQrCodeModal();
  const [processed, setProcessed] = useState(false);
  const [pendingPurchaseId, setPendingPurchaseId] = useState<number | null>(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const params = new URLSearchParams(search);
    const purchaseId = params.get("purchaseId");

    if (purchaseId && !processed) {
      const id = Number(purchaseId);
      setProcessed(true);

      if (token) {
        // 🔹 Já logado → abre o QR Code modal direto
        openModal({ compraId: id });
      } else {
        // 🔹 Não logado → salva o purchaseId e abre modal de registro
        setPendingPurchaseId(id);

        const modalEl = document.getElementById("register-modal");
        if (modalEl && (window as any).bootstrap?.Modal) {
          const modal = new (window as any).bootstrap.Modal(modalEl);
          modal.show();
        }
      }

      // limpa query param para não reabrir
      navigate(window.location.pathname, { replace: true });
    }
  }, [search, token, openModal, navigate, processed]);

  // 🔹 Depois do login/registro, se houver purchaseId pendente, abre o modal
  useEffect(() => {
    if (token && pendingPurchaseId !== null && !isOpen) {
      openModal({ compraId: pendingPurchaseId });
      setPendingPurchaseId(null);
    }
  }, [token, pendingPurchaseId, isOpen, openModal]);

  return isOpen && qrCodeData ? <QrCodeModal /> : null;
};

export default AppInitializer;
